import React, { useEffect, useMemo, useState } from "react";
import classNames from "classnames";
import { Link, useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useMediaQuery } from "_common/component/MediaQueryProvider";
import { useStores } from "_common/hooks";
import { observer } from "mobx-react-lite";
import iconUser from "assets/icons/icon_user.svg";
import iconBell from "assets/icons/icon_bell.svg";

const HeaderHome = observer(() => {
  const {
    authStore: { language, languages, user, general },
  } = useStores();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const langData = useMemo(
    () => languages?.find((obj) => obj?.code === language),
    [languages, language]
  );

  return (
    <div className="fixed top-0 left-0 w-full z-50 px-4 py-4 flex justify-between  bg-[#100F14]">
      <Link to="/member" className="flex items-center gap-2 ">
        <img
          src={iconUser}
          alt=""
          className="w-[40px] h-[40px] rounded-[50%]"
        />
        <div className="text-[16px] font-bold text-white flex items-center gap-1">
          {user?.username}
        </div>
      </Link>
      <div className="flex items-center gap-3">
        <div className="cursor-pointer">
          <img className="w-[25px] h-[25px]" src={iconBell} alt="" />
        </div>
        <Link
          className="flex items-center gap-2 cursor-pointer p-1 rounded hover:bg-[#19181d]"
          to="/language"
        >
          <img className="w-[20px]" src={langData?.image} alt="" />
          <span className="text-[14px] text-white">{langData?.text}</span>
        </Link>
      </div>
    </div>
  );
});

export default HeaderHome;
